import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { deleteBankAccount } from "./index.js";

export default function useDeleteBankAccount() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ bankAccountId }) => deleteBankAccount(ctx, bankAccountId),
    onSuccess: () => {
      // since a bank account is updated, fetching bank account should not be from cache
      queryClient.invalidateQueries({ queryKey: ["transaction-methods"] });
    },
  });
}
